module.exports = __webpack_public_path__ + "img/android_qrcode.01b1d7ff.png";